import axios from "axios";
import { api } from "./api_route";

// Organization Master

export const organizationState = async (values) => {
  try {
    const response = await axios.get(`${api}/organizationState/`);
    return {
      success: true,
      data: response.data?.data,
      message: "settings fetched successfully",
    };
  } catch (error) {
    console.error("Settings fetch error:", error);
    throw error;
  }
};

export const organizationZoneState = async (values) => {
  try {
    const response = await axios.get(
      `${api}/organizationState/organizationZoneState`
    );
    return {
      success: true,
      data: response.data?.data,
      message: "settings fetched successfully",
    };
  } catch (error) {
    console.error("Settings fetch error:", error);
    throw error;
  }
};

export const allState = async (values) => {
  try {
    const response = await axios.get(`${api}/organizationState/allStateData`);
    return {
      success: true,
      data: response.data?.data,
      message: "settings fetched successfully",
    };
  } catch (error) {
    console.error("Settings fetch error:", error);
    throw error;
  }
};

export const organizationStateCreate = async (values) => {
  try {
    const response = await axios.post(
      `${api}/organizationState/create`,
      values
    );
    return {
      success: true,
      data: response.data?.data,
      message: "settings fetched successfully",
    };
  } catch (error) {
    console.error("Settings fetch error:", error);
    throw error;
  }
};

export const organizationStateActive = async (id) => {
  try {
    const response = await axios.patch(`${api}/organizationState/${id}/status`);
    return {
      success: true,
      data: response.data.data,
      message: response.data.message || "Status updated successfully",
    };
  } catch (error) {
    console.error(
      "Status update error:",
      error.response?.data || error.message
    );
    throw {
      success: false,
      message: error.response?.data?.message || "Failed to update status",
      error: error.response?.data || error.message,
    };
  }
};

export const deleteOrganizationState = async (id) => {
  try {
    const response = await axios.delete(`${api}/organizationState/${id}`);
    return {
      success: true,
      data: response.data.data,
      message: response.data.message || "Deleted successfully",
    };
  } catch (error) {
    console.error("Delete error:", error.response?.data || error.message);
    throw {
      success: false,
      message: error.response?.data?.message || "Failed to delete",
      error: error.response?.data || error.message,
    };
  }
};
